import { render, staticRenderFns } from "./DocVerso.vue?vue&type=template&id=19e777ae&scoped=true&"
import script from "./DocVerso.vue?vue&type=script&lang=js&"
export * from "./DocVerso.vue?vue&type=script&lang=js&"
import style0 from "./DocVerso.vue?vue&type=style&index=0&id=19e777ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e777ae",
  null
  
)

export default component.exports